import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    // Your custom options can be added here if needed
    on: {
        init: () => window.lenis.stop(),
        destroy: () => window.lenis.start()
    }
});
